import type { AppAgg, CauseAgg, Page } from './utils';
import { fmtDec, fmtInt, rateTone, timeDomain } from './utils';
import { ProgressChart } from './ProgressChart';
import s from './BroadcastDetailsModal.module.css';

interface Props {
  pages: Page[];
  allPages: Page[];
  causes: CauseAgg[];
  apps: AppAgg[];
  cause: string | null;
  onCause: (k: string | null) => void;
  onOpenApp: (app: number) => void;
  appName: (id: number) => string;
}

export function ChartsTab({ pages, allPages, causes, apps, cause, onCause, onOpenApp, appName }: Props) {
  // domínio fixo pelo grupo inteiro: o eixo não "pula" ao filtrar
  const { d0, d1 } = timeDomain(allPages);
  const cmax = Math.max(...causes.map((c) => c.leads), 1);
  const ranked = apps.filter((a) => a.leads).sort((a, b) => b.rate - a.rate).slice(0, 7);
  const rmax = Math.max(...ranked.map((a) => a.rate), 1);

  return (
    <div className={s.chartsTab}>
      <ProgressChart pages={pages} d0={d0} d1={d1} />
      <div className={s.twoCols}>
        <div className={s.card}>
          <div className={s.cardHead}><span className={s.cardTitle}>Falhas por causa</span><span className={s.cardSub}>leads · clique para destacar</span></div>
          <div className={s.barList}>
            {causes.length === 0 && <span className={s.muted}>Sem falhas</span>}
            {causes.map((c) => (
              <button key={c.key} type="button" title={c.description} className={s.barRow} style={{ gridTemplateColumns: '150px minmax(0,1fr) 110px', opacity: !cause || cause === c.key ? 1 : 0.5 }}
                onClick={() => onCause(cause === c.key ? null : c.key)}>
                <span className={s.barLabel}><i className={s.sq} style={{ background: c.color }} />{c.label}</span>
                <span className={s.track}><span style={{ width: `${Math.max((c.leads / cmax) * 100, 0.5)}%`, background: c.color }} /></span>
                <span className={s.barVal}><b>{c.leads ? fmtInt(c.leads) : '—'}</b> <small>{c.pages} pág.</small></span>
              </button>
            ))}
          </div>
        </div>
        <div className={s.card}>
          <div className={s.cardHead}><span className={s.cardTitle}>Taxa de falha por app</span><span className={s.cardSub}>clique para abrir na Distribuição</span></div>
          <div className={s.barList}>
            {ranked.map((a) => {
              const t = rateTone(a.rate);
              return (
                <button key={a.app} type="button" className={s.barRow} style={{ gridTemplateColumns: '190px minmax(0,1fr) 120px' }} onClick={() => onOpenApp(a.app)}>
                  <span className={s.barLabel} title={appName(a.app)}><b className={s.ellipsis}>{appName(a.app)}</b></span>
                  <span className={s.track}><span style={{ width: `${Math.max((a.rate / rmax) * 100, 1)}%`, background: t.bar }} /></span>
                  <span className={s.barVal}><b style={{ color: t.fg }}>{a.rate === 0 && a.fail > 0 ? '<0,1' : fmtDec(a.rate)}%</b> <small>{fmtInt(a.fail)} de {fmtInt(a.leads)}</small></span>
                </button>
              );
            })}
          </div>
        </div>
      </div>
    </div>
  );
}
